import firebase from 'firebase/compat/app';
import { firebaseConfig } from './firebaseconfig';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import Swal from 'sweetalert';
import { enviarNotificacaoParaTodos } from './mensagens';

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const storage = firebase.storage();

// PEGAR O ANO ATUAL
const dataAtual = new Date();
const anoAtual = dataAtual.getFullYear();
localStorage.setItem('ano', anoAtual);
const ANO = localStorage.getItem('ano');

const lerComunicados = async () => {
    const comunicados = [];
    
    try {
        const snapshot = await db.collection(ANO)
            .doc('avisos')
            .collection('avisos')
            .orderBy('data', 'desc')
            .limit(10)
            .get();

        await Promise.all(snapshot.docs.map(async (doc) => {
            const uid = doc.id;
            const titulo = doc.data().titulo;
            const mensagem = doc.data().mensagem;
            const imagem = doc.data().imagem;

            if (imagem && imagem !== "null") {
                const storageRef = await storage.ref(`${ANO}/avisos/${imagem}`);
                await storageRef.getDownloadURL()
                .then((url) => {
                    comunicados.push({
                        id: uid,
                        titulo: titulo,
                        mensagem: mensagem,
                        imagem: url,
                        nomeImagem: imagem,
                    });
                })
                .catch((error) => {
                    if (error.code === 'storage/object-not-found') {
                        comunicados.push({
                            id: uid,
                            titulo: titulo,
                            mensagem: mensagem,
                        });
                    } else {
                        console.error("Error checking if the storage exists:", error);
                    }
                });
            } else {
                comunicados.push({
                    id: uid,
                    titulo: titulo,
                    mensagem: mensagem,
                });
            }
        }));

        return comunicados;
    } catch (error) {
        return error;
    }
};

const enviarComunicado = async (file, titulo, mensagem) => {
    const enviar = new Promise( async (resolve, reject) => {
        try {
            if (titulo && mensagem) {
            
                if (file) {
                    const storageRef = await storage.ref(`${ANO}/avisos/${file.name}`);
                
                    await storageRef.put(file).then(function (snapshot) {
                        
                    }).catch(function (error) {
                        console.error("Erro ao enviar a imagem:", error);
                    });
                }

                var imagem = '';
                if (file) {
                    imagem = file.name;
                } else {
                    imagem = 'null';
                }

                // Enviando Valores
                await db.collection(ANO)
                .doc('avisos')
                .collection('avisos')
                .doc(titulo)
                .set({
                    titulo: titulo,
                    mensagem: mensagem,
                    imagem: imagem,
                    data: firebase.firestore.FieldValue.serverTimestamp(),
                }).then( async (response) => {
                    
                    const resposta = await enviarNotificacaoParaTodos('Comunicado', mensagem) || false;
                    
                    if (resposta) {
                        await Swal({
                            title: 'Comunicado Enviado e Notificado com sucesso!',
                            icon: 'success',
                            buttons: {
                                confirm: 'Ok',
                            },
                        }).then((resposta) => {
                            window.location.reload();
                        });
                    } else {
                        await Swal({
                            title: 'Comunicado Enviado com sucesso!',
                            icon: 'success',
                            buttons: {
                                confirm: 'Ok',
                            },
                        }).then((resposta) => {
                            window.location.reload();
                        });
                    }
                    
                });
            } else if (file && !titulo && !mensagem) {
                
                // Crie uma referência para o local de armazenamento da imagem
                const storageRef = await storage.ref(`${ANO}/avisos/${file.name}`);
                // Faça o upload da imagem para o Firebase Storage
                await storageRef.put(file).then(function (snapshot) {
                    
                }).catch(function (error) {
                    console.error("Erro ao enviar a imagem:", error);
                });
                
                // Coletando valores
                var imagem = '';
                if (file) {
                    imagem = file.name;
                } else {
                    imagem = 'null';
                }

                // Enviando Valores
                await db.collection(ANO)
                .doc('avisos')
                .collection('avisos')
                .doc()
                .set({
                    imagem: imagem,
                    data: firebase.firestore.FieldValue.serverTimestamp(),
                }).then( async (response) => {
                    
                    await enviarNotificacaoParaTodos('Comunicado', mensagem);
                    
                    await Swal({
                        title: 'Comunicado Enviado com sucesso!',
                        icon: 'success',
                        buttons: {
                            confirm: 'Ok',
                        },
                    }).then((resposta) => {
                        window.location.reload();
                    });
                });
            } else {
                Swal({
                    title: 'Complete o formulário corretamente!',
                    icon: 'error',
                    buttons: {
                      confirm: 'Ok',
                    },
                });
            }
        } catch (error) {
            console.log(error);
        }
    });

    return enviar;
};

const excluirComunicado = async (id, imagem) => {
    const excluir = new Promise( async (resolve, reject) => {
        try {
            await Swal({
                title: `Você deseja excluir o comunicado '${id}'?`,
                icon: 'warning',
                buttons: {
                  confirm: 'Sim',
                  cancel: 'Não',
                },
            }).then( async (resposta) => {
                if (resposta) {
                    await db.collection(ANO)
                    .doc('avisos')
                    .collection('avisos')
                    .doc(id).delete();
                    
                    if (imagem) {
                        const storageRef = await storage.ref(`${ANO}/avisos/${imagem}`);
                        await storageRef.delete();
                    }

                    await Swal({
                        title: `Comunicado '${id}' excluido com sucesso!`,
                        icon: 'success',
                        buttons: {
                        confirm: 'Ok',
                        },
                    }).then((res) => {
                        window.location.reload();
                    })
                }
            })
            
        } catch (error) {
            console.log(error);
        }
    });

    return excluir;
};

export { lerComunicados, enviarComunicado, excluirComunicado };